import React from "react";
import { styled } from "styled-components";
const StyledCloseButton = styled.button `
  background-color: inherit;
  border: 2px solid transparent;
  border-radius: 4px;
  color: inherit;
  cursor: pointer;
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  margin-right: -0.5rem;
  margin-top: -0.5rem;
  padding: 0 0.25rem;

  &:active,
  &:hover,
  &:focus {
    border-color: #0000ff;
    outline: none;
  }

  > .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;
export const CloseButton = ({ children, onClick, }) => (React.createElement(StyledCloseButton, { onClick: onClick },
    React.createElement("span", { "aria-hidden": "true" }, "\u00D7"),
    React.createElement("span", { className: "sr-only" }, children)));
export default CloseButton;
//# sourceMappingURL=CloseButton.js.map